import { Dispatch, MutableRefObject, useEffect } from 'react'

import { Action, DrawingActionKind, DrawResult } from 'features/locationMap/types'

export function useDrawingManagerEvents(
  drawingManager: google.maps.drawing.DrawingManager | null,
  overlaysShouldUpdateRef: MutableRefObject<boolean>,
  dispatch: Dispatch<Action>,
) {
  useEffect(() => {
    if (!drawingManager) return () => undefined

    const eventListeners: Array<google.maps.MapsEventListener> = []

    const addUpdateListener = (eventName: string, drawResult: DrawResult) => {
      const updateListener = google.maps.event.addListener(drawResult.overlay, eventName, () => {
        if (eventName === 'dragstart') {
          overlaysShouldUpdateRef.current = false
        }

        if (eventName === 'dragend') {
          overlaysShouldUpdateRef.current = true
        }

        if (overlaysShouldUpdateRef.current) {
          dispatch({ type: DrawingActionKind.UPDATE_OVERLAYS })
        }
      })

      eventListeners.push(updateListener)
    }

    const overlayCompleteListener = google.maps.event.addListener(
      drawingManager,
      'overlaycomplete',
      (drawResult: DrawResult) => {
        addUpdateListener('mouseup', drawResult)

        dispatch({ type: DrawingActionKind.SET_OVERLAY, payload: drawResult })
      },
    )

    eventListeners.push(overlayCompleteListener)

    return () => {
      eventListeners.forEach(listener => google.maps.event.removeListener(listener))
    }
  }, [dispatch, drawingManager, overlaysShouldUpdateRef])
}
